module.exports = __webpack_public_path__ + "static/media/MetaMaskCompleteGuide.4fd11a22.pdf";